// To Capitalize first letter
/*
window.addEventListener('DOMContentLoaded', (event) => {
    var allSwatches= document.querySelectorAll(".block-swatch-list .block-swatch__item-text");
    capitalizeFirst(allSwatches);

    var nextStepBtn= document.querySelector(".button.tw-font-medium.button--ternary.tw-mr-6");
    capitalizeFirst(nextStepBtn);

    var allSwatches2= document.querySelectorAll("#shopify-section-template--16000383844594__main .block-swatch-list .block-swatch__item-text");

    capitalizeFirst(allSwatches2);


    var nextStepBtn2= document.querySelector("#shopify-section-template--16000383844594__main .button.tw-font-medium.button--ternary.tw-mr-6");

    capitalizeFirst(nextStepBtn2);



    function capitalizeFirst(items){
      if(items.length>0){
        items.forEach((item)=>{
          item.innerText = item.innerText.toLowerCase().replace(/\b(\w)/g, x => x.toUpperCase());
        })
      }else{
        if(items){
          items.innerText = items.innerText.toLowerCase().replace(/\b(\w)/g, x => x.toUpperCase());
        }
      }
    }
});
*/
// window.addEventListener('DOMContentLoaded', (event) => {
//   new flickityFade(element.querySelector('.slideshow')
// });

// window.addEventListener("resize", (evt)=>{
//     var sliders = document.querySelectorAll("[data-flickity]")
//     sliders.forEach(slider =>{
//       setTimeout(()=>{
//         Flickity.data(slider).reloadCells();
//         Flickity.data(slider).reposition();
//       },10)
//     })
// })

// Get the image url and title from localStorage and set the image attribute to it so we can display the selected door
function cabinetUpdateSelectedDoor(){
  var selectedDoorImgUrl = localStorage.getItem('builder:doorImgUrl');
  var selectedDoorImgTitle = localStorage.getItem('builder:doorTitle');
  var imageEl = document.querySelector(".selectedDoorImg");
  var ImageTitle = document.querySelector(".selectedDoorTitle");
  var mobileImageEl = document.querySelector(".selectedDoorImg");
  var mobileImageTitle = document.querySelector(".selectedDoorTitle");
  if(imageEl && ImageTitle){
    imageEl.src = selectedDoorImgUrl
    ImageTitle.innerText = selectedDoorImgTitle;
    mobileImageEl.src = selectedDoorImgUrl
    mobileImageTitle.innerText = selectedDoorImgTitle;
  }
}
cabinetUpdateSelectedDoor()

// Get the kitchen image url and title from localStorage and set the image attribute to it so we can display the selected Kitchen
// This function has been called in the (kitchen-builder.js) at row 267 so it can be updated
// after the Ajax update the page
function cabinetUpdateSelectedKithchen(){
  var selectedKitchenImgUrl = localStorage.getItem('builder:KbImgUrl');
  var selectedKitchenName = localStorage.getItem('builder:KbName');
  var selectedKitchenDesc = localStorage.getItem('builder:KbDescription');
  var selectedDoorImgTitle = localStorage.getItem('builder:doorTitle');

  var kbImage = document.querySelector(".hp-kitchen-image-with-text img");
  var kbTitle = document.querySelector(".hp-kitchen-image-with-text .title");
  var kbDesc = document.querySelector(".hp-kitchen-image-with-text .description");
  console.log(kbImage);
  if(kbImage && kbTitle){
    kbImage.src = selectedKitchenImgUrl;
    kbTitle.innerText = selectedKitchenName + " " + selectedDoorImgTitle;
    kbDesc.innerText = selectedKitchenDesc
  }
}
cabinetUpdateSelectedKithchen();

// Function to show the selected door in the Kitchen Builder accessories page
// This function has been called in the (kitchen-builder.js) at row 267 so it can be updated
// after the Ajax update the page
function accessoriesUpdateSelectedDoor(){
  var selectedDoorImgUrl = localStorage.getItem('builder:doorImgUrl');
  var selectedDoorImgTitle = localStorage.getItem('builder:doorTitle');
  var imageEl = document.querySelector(".accessoriesPg .selectedDoorImg");
  var ImageTitle = document.querySelector(".accessoriesPg .selectedDoorTitle");
  var mobileImageEl = document.querySelector(".mobile-filter .accessoriesPg .selectedDoorImg");
  var mobileImageTitle = document.querySelector(".mobile-filter .accessoriesPg .selectedDoorTitle");
  if(imageEl && ImageTitle){
    imageEl.src = selectedDoorImgUrl
    ImageTitle.innerText = selectedDoorImgTitle;
    mobileImageEl.src = selectedDoorImgUrl
    mobileImageTitle.innerText = selectedDoorImgTitle;
  }
}


// Function to prevent the quantity selector update if the hinge side is not selected
function preventQty(){

  var items = document.querySelectorAll("[data-finishes]")
  items.forEach(i=>{
    var hingSide = i.querySelector('.select-wrapper--primary select')
    var qtyWrapper = i.querySelector('.quantity-selector-wrapper')
    var qtySelector = i.querySelector('.quantity-selector-wrapper .quantity-selector')

    qtyWrapper.addEventListener('click', function(){
      if(hingSide && hingSide.value === ''){
        hingSide.style.color = "red"
      }
    })

    if(hingSide){
      hingSide.addEventListener('change', function(el){
       
        qtySelector.style.pointerEvents = "auto";
        hingSide.style.color = "inherit"
      })
    }
  })

  activateNoHingeSideProducts();
}

function activateNoHingeSideProducts() {
  var noHingeProducts = document.querySelectorAll("[data-no-hing-side]");
  noHingeProducts.forEach((product)=>{
    var qtySelector = product.querySelector('.quantity-selector-wrapper .quantity-selector')
    qtySelector.style.pointerEvents = "auto";
  })
}

//function to update the product card price of the cabinets of complete kitchens
// This function has been called in the (theme.js) at row 14314
function updateOverHangPrice(){
  var overHangProducts = document.querySelectorAll("[data-has-overhang]");
  var overHangPrice = window.overhangProductPrice;
  overHangProducts.forEach((product)=>{
    var overhangInput = product.querySelector("[type=checkbox]")
    var productOriginalPrice = product.querySelector("[data-price]").getAttribute("data-price");
    var priceContainer = product.querySelector(".product-item__price-list span")
    
    overhangInput.addEventListener("change",()=>{
      var totalPrice = parseInt(productOriginalPrice);
      if(overhangInput.checked){
        totalPrice = parseInt(productOriginalPrice) + parseInt(overHangPrice);
      }
      priceContainer.innerHTML = `£${totalPrice/100}`;
    })
  })
}

updateOverHangPrice()